import Xtc from "./model/Xtc";
import XTbl from "./model/XTbl";

export {Xtc};
export default XTbl;

